// 3rd party libs
import cx from 'classnames';
import React from 'react';

// local imports
import TrashIcon from '../../../assets/icons/trash.svg';
import styles from './TrashButton.module.scss';

type TTrashButton = {
  onClick?: (e?: any) => void;
  small?: boolean;
  className?: string;
  style?: any;
};
const TrashButton: React.FC<TTrashButton> = ({ onClick, small, className, style }) => {
  return (
    <img
      style={{ ...style }}
      onClick={onClick}
      className={cx(small ? styles.btnSmall : styles.btn, className)}
      src={TrashIcon}
      alt="delete icon"
    />
  );
};

export default TrashButton;
